import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
import CustomTextField from "../GRI300/GRI308/CustomTextField";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic224 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    responsibilityAllocation: {
      conductTroughtoutBusiness: "",
      allocatesResponbiltity: "",
      commitmentIntegrationStrategies: "",
      busineessRelationShip: "",
      busineesConductEffectively: "",
    },
  });
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `/gri/get?type=GeneralDisclosures2021&Id=${id}`
        );
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data =
          response.data.data.GeneralDisclosures2021
            ?.emeddingPolicyCommitments || {};

        setFormData({
          responsibilityAllocation: {
            conductTroughtoutBusiness:
              data.responsibilityAllocation?.conductTroughtoutBusiness || "",
            allocatesResponbiltity:
              data.responsibilityAllocation?.allocatesResponbiltity || "",
            commitmentIntegrationStrategies:
              data.responsibilityAllocation?.commitmentIntegrationStrategies ||
              "",
            busineessRelationShip:
              data.responsibilityAllocation?.busineessRelationShip || "",
            busineesConductEffectively:
              data.responsibilityAllocation?.busineesConductEffectively || "",
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Remove error for the specific field
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    // Validate required fields in the formData
    if (!formData.responsibilityAllocation.conductTroughtoutBusiness) {
      newErrors.conductTroughtoutBusiness = "This field is required";
      formIsValid = false;
    }

    if (!formData.responsibilityAllocation.allocatesResponbiltity) {
      newErrors.allocatesResponbiltity = "This field is required";
      formIsValid = false;
    }

    if (!formData.responsibilityAllocation.commitmentIntegrationStrategies) {
      newErrors.commitmentIntegrationStrategies = "This field is required";
      formIsValid = false;
    }

    if (!formData.responsibilityAllocation.busineessRelationShip) {
      newErrors.busineessRelationShip = "This field is required";
      formIsValid = false;
    }

    if (!formData.responsibilityAllocation.busineesConductEffectively) {
      newErrors.busineesConductEffectively = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      const payload = {
        type: "GeneralDisclosures2021",
        emeddingPolicyCommitments: {
          ...formData,
        },
         submitted2_24: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/general-disclosure/2-25/${id}`);
      } catch (error) {
        console.error("Error updating data:", error);
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-25/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      <p className={styles.main_heading}>2-24 Embedding policy commitments</p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}
        <SectionHeading
          text="a. Describe how organization embeds each of its policy commitments for responsible business conduct throughout its activities and business relationships."
          sx={{ marginTop: hide ? "-1rem" : "0rem" }}
        />
        <CustomTextField
          value={formData.responsibilityAllocation.conductTroughtoutBusiness}
          onChange={(e) =>
            handleNestedInputChange(
              "responsibilityAllocation",
              "conductTroughtoutBusiness",
              e.target.value
            )
          }
          error={errors.conductTroughtoutBusiness}
          helperText={errors.conductTroughtoutBusiness}
          disabled={disabled}
        />
        <Box sx={{ marginLeft: "1.1rem" }}>
          <SectionHeading text="i. Describe how organization allocates responsibility to implement the commitments across different levels within the organization." />
          <CustomTextField
            value={formData.responsibilityAllocation.allocatesResponbiltity}
            onChange={(e) =>
              handleNestedInputChange(
                "responsibilityAllocation",
                "allocatesResponbiltity",
                e.target.value
              )
            }
            error={errors.allocatesResponbiltity}
            helperText={errors.allocatesResponbiltity}
            disabled={disabled}
          />

          <SectionHeading text="ii. Describe how organization integrates the commitments into organizational strategies, operational policies, and operational procedures " />
          <CustomTextField
            value={
              formData.responsibilityAllocation.commitmentIntegrationStrategies
            }
            // onChange={(e) => handleNestedInputChange("commitmentIntegrationStrategies", e.target.value)}
            onChange={(e) =>
              handleNestedInputChange(
                "responsibilityAllocation",
                "commitmentIntegrationStrategies",
                e.target.value
              )
            }
            error={errors.commitmentIntegrationStrategies}
            helperText={errors.commitmentIntegrationStrategies}
            disabled={disabled}
          />

          <SectionHeading text="iii. Describe how organization implements its commitments with and through its business relationships. " />
          <CustomTextField
            value={formData.responsibilityAllocation.busineessRelationShip}
            // onChange={(e) => handleNestedInputChange("busineessRelationShip", e.target.value)}
            onChange={(e) =>
              handleNestedInputChange(
                "responsibilityAllocation",
                "busineessRelationShip",
                e.target.value
              )
            }
            error={errors.busineessRelationShip}
            helperText={errors.busineessRelationShip}
            disabled={disabled}
          />

          <SectionHeading text="iv. Describe training programs or initiatives that the organization provide to equip its employees with the knowledge and skills to implement the responsible business conduct commitments effectively. " />
          <CustomTextField
            value={formData.responsibilityAllocation.busineesConductEffectively}
            // onChange={(e) => handleNestedInputChange("busineesConductEffectively", e.target.value)}
            onChange={(e) =>
              handleNestedInputChange(
                "responsibilityAllocation",
                "busineesConductEffectively",
                e.target.value
              )
            }
            error={errors.busineesConductEffectively}
            helperText={errors.busineesConductEffectively}
            disabled={disabled}
          />
        </Box>

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic224;
